var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nomore"},[_c('img',{staticClass:"nomore_img",attrs:{"src":require("@/assets/schoolScreen/school_overview/nomore.png"),"alt":""}}),_c('div',{staticClass:"t"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }